<template>
    <rkm-layout-body title="Lista de especialidade">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'cadastro-especialidade-create'})"
                authorize="store-cadastro-especialidade"
                color="primary"
            >
                Cadastrar especialidade
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/especialidade/List'

export default {
    components: {List},
}
</script>